const DataFilter_view5 = (thaiData,selectedYear,view, streamReady, CODFormat, selectedDay) => {

    let dataFilter = null;

    if(thaiData!=null){
        let dataSelect = {};

        if(streamReady){
            if(view === 5){
                dataSelect = {
                    'view_5_single': thaiData[0].view_5_single,
                    'view_5_all': thaiData[1].view_5_all,
                };
            }
        }
        
        let dataFilter;

        const yearFilter = (dataFilter, year) => {
            const dataByYear = dataFilter.filter(function (data) {
                return data.Date.includes(year) || data.Date.includes(year+1);
              });
            return dataByYear;
        }

        const CODFilter = (dataFilter, cod) => {
            let i = 0;
            const dataByCOD = dataFilter.filter(function (data) {
                for(i=0;i<cod.length;i++){
                    if(data.NCAUSE_GROUP.includes(cod[i])){
                        return data; 
                    }
                }
              });
            return dataByCOD;
        }

        const noDataFilter = (dataFilter) => {
            const dataByAvailable = dataFilter.filter(function (data) {
                return data['Excess Death Percent'] !== -100;
            });
            return dataByAvailable;
        }

        const filter_by_cond = (dataFilter) => {
            if( view === 5 ){
                    if(CODFormat.includes("All")){
                        dataFilter = yearFilter(dataSelect.view_5_all, selectedYear);
                    } else {
                        dataFilter = yearFilter(dataSelect.view_5_single, selectedYear);
                        dataFilter = CODFilter(dataFilter, CODFormat);
                        dataFilter = noDataFilter(dataFilter); 
                    }
                }
            return {dataFilter};
        }
        
        dataFilter = filter_by_cond(dataFilter);
       
        return dataFilter;
    }

    return {dataFilter};
}
 
export default DataFilter_view5;